<template>
  <div id="home">
    <div v-if="Artcle" style="padding:0 0;position:relative;">
      <div v-if="Artcle.content" v-html="markedGet(Artcle.content)" ref="ahtml" style="margin-top:1rem;"></div>
    </div>
  </div>
</template>
<script>
import {
  SfHero,
  SfBanner,
  SfCallToAction,
  SfSection,
  SfCarousel,
  SfProductCard,
  SfImage,
  SfBannerGrid,
  SfHeading,
  SfArrow,
  SfButton
} from '@storefront-ui/vue';
// useContext,
import { computed, ref, onMounted } from '@nuxtjs/composition-api';
import { onSSR } from '@vue-storefront/core';
import { useArtcleOne } from '@bee-hole/coms';
// const marked = require('marked');

export default {
  name: 'Home1',
  components: {
    SfHero,
    SfBanner,
    SfCallToAction,
    SfSection,
    SfCarousel,
    SfProductCard,
    SfImage,
    SfBannerGrid,
    SfHeading,
    SfArrow,
    SfButton
  },
  setup(props, context) {
    // console.log('context', context);
    // console.log('context', context);
    // const { $config } = useContext();
    const loading = ref(false);
    const ahtml = ref();
    const aid = computed(() => {
      let id;
      const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
      if (config === 'number') {
        id = context?.root?.$options?.$mallConfig?.mall_home_artice;
      } else {
        id = context?.root?.$options?.$mallConfig?.mall_home_artice?.aid;
      }
      return id;
    });
    // const { configList } = useConfig('mall_zx_home');
    const { articleOneGet, artcle } = useArtcleOne();
    const markedGet = (val) => {
      return (val);
    };
    const Artcle = computed(() => {
      return artcle.value;
    });
    onMounted(() => {
      try {
        if (loading.value) {
          return false;
        }
        loading.value = true;
        // 通过ref获取到所有有usemap的dom元素
        const imgs = ahtml.value.querySelectorAll('img[usemap]');
        // 通过遍历所有的dom元素，通过usemap的值获取到对应的map元素
        imgs?.forEach((img, index) => {
          // 获取img元素的height和width
          const alt = img.getAttribute('alt');
          if (index !== -1 && alt.indexOf('autosize1') !== -1) {
            // 对每个元素执行相应操作
            const mapName = img.useMap.replace('#', '');
            const map = ahtml.value.querySelector(`map[name=${mapName}]`);
            // 获取到map元素下所有的area元素
            const areas = map.querySelectorAll('area');
            // const imgWidth = img.width;
            // const imgHeight = img.height;
            const imgHeight = img.getAttribute('height');
            const imgWidth = img.getAttribute('width');
            // 遍历所有的area元素，获取到对应的href值
            const newImg = ahtml.value.querySelector('img[usemap=' + `"#${mapName}"` + ']');
            const newImgWidth = newImg.clientWidth;
            const newImgHeight = newImg.clientHeight;
            const widthRatio = Number(newImgWidth / imgWidth).toFixed(2);
            const heightRatio = Number(newImgHeight / imgHeight).toFixed(2);
            areas.forEach(area => {
              // 根据img按newimg的比例缩放area的坐标
              const coords = area.coords.split(',');
              const adjustedCoords = coords.map((value, index) => {

                const adjustedValue = index % 2 === 0 ? value * widthRatio : value * heightRatio;
                // 将每一个调整后的坐标值四舍五入到指定的小数位数
                return Number(adjustedValue.toFixed(2));
              }
              );
              area.style.backgroundColor = 'red';
              // 判断area.href有值且是已/开头
              //
              const href = area.getAttribute('href');
              const locale = context?.root?.$cookies.get('vsf-locale');
              if (href && href.charAt(0) === '/' && locale) {
                area.setAttribute('href', `${ '/' + locale}${href}`);
              }
              area.coords = adjustedCoords;
            });
          } else if (index !== -1 && alt.indexOf('autosize0') !== -1) {
            // 对每个元素执行相应操作
            const mapName = img.useMap.replace('#', '');
            const map = ahtml.value.querySelector(`map[name=${mapName}]`);
            // 获取到map元素下所有的area元素
            const areas = map.querySelectorAll('area');
            areas.forEach(area => {
              const href = area.getAttribute('href');
              const locale = context?.root?.$cookies.get('vsf-locale');
              if (href && href.charAt(0) === '/' && locale) {
                area.setAttribute('href', `${ '/' + locale}${href}`);
              }
            });
          }
        });
        const videos = ahtml.value?.querySelectorAll('video');
        videos?.forEach((video) => {
          if (video.autoplay) {
            setTimeout(() => {
              video.play();
            }, 1000);
          }
        });
      } catch (e) {
        console.log('e', e);
      }
    });
    onSSR(async () => {
      //   await configList({
      //     name: 'mall_zx_home'
      //   });
      await articleOneGet({ article_id: aid.value });
    });
    return {
      ahtml,
      // isMobile
      Artcle,
      markedGet
    };
  }
};
</script>

<style lang="scss" scoped>
#home {
    box-sizing: border-box;
    padding: 0 var(--spacer-sm);
    @include for-mobile {
      min-height: 700px;
  }
    // position:relative;
    @include for-desktop {
        max-width: 1240px;
        padding: 0;
        margin: 0 auto;
        min-height: 600px;
    }
}

.hero {
    margin: var(--spacer-xl) auto var(--spacer-lg);
    --hero-item-background-position: center;

    @include for-desktop {
        margin: var(--spacer-xl) auto var(--spacer-2xl);
    }

    .sf-hero-item {
        &:nth-child(even) {
            --hero-item-background-position: left;

            @include for-mobile {
                --hero-item-background-position: 30%;

                ::v-deep .sf-hero-item__subtitle,
                ::v-deep .sf-hero-item__title {
                    text-align: right;
                    width: 100%;
                    padding-left: var(--spacer-sm);
                }
            }
        }
    }

    ::v-deep .sf-hero__control {

        &--right,
        &--left {
            display: none;
        }
    }
}

.banner-grid {
    --banner-container-width: 50%;
    margin: 0 0 var(--spacer-xl) 0;

    ::v-deep .sf-link:hover {
        color: var(--c-white);
    }

    @include for-desktop {
        margin: var(--spacer-2xl) 0;

        ::v-deep .sf-link {
            --button-width: auto;
            text-decoration: none;
        }
    }
}

.banner {
    &__tshirt {
        background-position: left;
    }

    &-central {
        @include for-desktop {
            --banner-container-flex: 0 0 70%;
        }
    }
}

.similar-products {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: var(--spacer-2xs);
    --heading-padding: 0;
    border-bottom: 1px var(--c-light) solid;

    @include for-desktop {
        border-bottom: 0;
        justify-content: center;
        padding-bottom: 0;
    }
}

.call-to-action {
    background-position: right;
    margin: var(--spacer-xs) 0;

    @include for-desktop {
        margin: var(--spacer-xl) 0 var(--spacer-2xl) 0;
    }
}

.carousel {
    margin: 0 calc(0 - var(--spacer-sm)) 0 0;

    @include for-desktop {
        margin: 0;
    }

    &__item {
        margin: 1.375rem 0 2.5rem 0;

        @include for-desktop {
            margin: var(--spacer-xl) 0 var(--spacer-xl) 0;
        }

        &__product {
            --product-card-add-button-transform: translate3d(0, 30%, 0);
        }
    }

    ::v-deep .sf-arrow--long .sf-arrow--right {
        --arrow-icon-transform: rotate(180deg);
        -webkit-transform-origin: center;
        transform-origin: center;
    }
}
</style>
